export default __webpack_public_path__ + "static/media/background1.8de3dddc.jpg";